module.exports = "<input type=\"checkbox\" class=\"kuiCheckBox\">\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/form/check_box.html
 ** module id = 730
 ** module chunks = 0
 **/